import CharacterHeaderInfo from "./CharacterHeaderInfo";

export default CharacterHeaderInfo;
export { CharacterHeaderInfo };
